// Test: V_DH_SITE_12 — Larger Text Sizes Sitewide for 55+ Readability

(function () {
  // Custom events fire for every visitor bucketed into the test — Control and
  // Var A — so Intelligems can compare the two arms.
  function vDhSite12InTest() {
    return !!(window.igData && window.igData.user &&
      window.igData.user.getTestGroup('fc608619-4c27-48b6-aaff-b2580835f262'));
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var event = null;
    // add_to_cart_click — PDP Add To Cart (main or sticky bar)
    if (e.target.closest('.product-form__submit, .sticky-atc__button')) event = 'add_to_cart_click';
    // checkout_click — cart drawer Checkout button
    else if (e.target.closest('#CartDrawer-Checkout')) event = 'checkout_click';
    if (!event || !vDhSite12InTest()) return;
    window.igEvents = window.igEvents || [];
    window.igEvents.push({ event: event });
  });

  // Global rule — every element not given an exact size in c-custom.css is scaled
  // by band: ≤13 ×1.28 · 14–19 ×1.25 · 20–27 ×1.22 · 28–40 ×1.14 · 41+ ×1.06,
  // and line-height +3%. Sizes are written inline in px from each element's
  // original computed size, so nested elements never compound. They are written
  // with !important so app/theme rules marked !important (Globo, Loox, size guide,
  // personalisation title) can't keep their old size.
  var VDH_SITE12_CLASS = 'c-vDhSite12VarA';

  // Elements sized exactly by the spec table in c-custom.css (and their subtrees)
  var VDH_SITE12_EXACT = [
    '.product__title h1',
    '.product__title .h1',
    '.product__info-container .price-item',
    '.service-guarantees__text',
    '.globo-swatch-product-detail .name-option',
    '.product-form__input .form__label',
    '.product-form__submit',
    '.sticky-atc__button',
    '.cart__checkout-button',
    '.cart-upsell__button',
    '.c-pdp-modal__add',
    '.card__heading',
    '.card-wrapper .price-item',
    '.card-wrapper .badge',
    '.card-wrapper .price-discount-badge',
    '.rating-count',
    '.loox-rating .loox-rating-label',
    '.header__inline-menu .header__menu-item',
    '.menu-drawer__menu-item',
    '.swatch--gl .name-option'
  ].join(',');

  // Other tests' blocks with their own Figma sizes — left completely untouched (font-size and line-height)
  var VDH_SITE12_IGNORE = [
    '.c-cart11-urgency-block'
  ].join(',');

  var VDH_SITE12_SKIP_TAGS =/^(SCRIPT|STYLE|LINK|META|NOSCRIPT|TEMPLATE|BR|IMG|PICTURE|SOURCE|VIDEO|AUDIO|IFRAME|CANVAS|OBJECT|EMBED)$/;

  // Elements touched, with their original inline values so a re-run can restore them
  var vDhSite12Touched = [];
  // Elements already scaled (or exact) — never scaled twice
  var vDhSite12Done = new WeakSet();
  var vDhSite12Started = false;

  function vDhSite12Multiplier(px) {
    if (px < 13.5) return 1.28;
    if (px < 19.5) return 1.25;
    if (px < 27.5) return 1.22;
    if (px < 40.5) return 1.14;
    return 1.06;
  }

  function vDhSite12Collect(el, out) {
    if (VDH_SITE12_SKIP_TAGS.test(el.tagName) || el instanceof SVGElement) return;
    if (vDhSite12Done.has(el)) return;
    if (el.matches(VDH_SITE12_IGNORE)) return;
    var exact = el.matches(VDH_SITE12_EXACT);
    out.push({ el: el, exact: exact });
    if (exact) return;
    for (var i = 0; i < el.children.length; i++) vDhSite12Collect(el.children[i], out);
  }

  // Reads every element under root first, then writes in one pass, so layout is
  // only recalculated once. An element whose size matches an already-scaled
  // parent is inheriting the scaled size, so it is left alone — this is what keeps
  // content rendered later (cart drawer, app widgets) from being scaled twice.
  function vDhSite12Scale(root) {
    if (root.parentElement && root.parentElement.closest(VDH_SITE12_EXACT)) return;
    if (root.closest(VDH_SITE12_IGNORE)) return;

    var items = [];
    vDhSite12Collect(root, items);

    var writes = [];
    items.forEach(function (item) {
      var el = item.el;
      var style = getComputedStyle(el);
      var px = parseFloat(style.fontSize);
      var parent = el.parentElement;

      var lh = style.lineHeight;
      var ratio = lh === 'normal' || !px ? null : parseFloat(lh) / px;
      var parentScaled = parent && vDhSite12Done.has(parent);
      var parentStyle = parentScaled ? getComputedStyle(parent) : null;

      if (!item.exact && parentScaled && Math.abs(parseFloat(parentStyle.fontSize) - px) < 0.01) {
        // Remembered globally: content inserted inside it later must not be scaled again
        vDhSite12Done.add(el);
        return;
      }

      // A line-height ratio matching a scaled parent's is inherited — already +3%
      var lhInherited = ratio !== null && parentScaled && parentStyle.lineHeight !== 'normal' &&
        Math.abs(parseFloat(parentStyle.lineHeight) / parseFloat(parentStyle.fontSize) - ratio) < 0.001;

      writes.push({
        el: el,
        fontPx: item.exact || !px ? null : +(px * vDhSite12Multiplier(px)).toFixed(2),
        lineHeight: ratio === null || lhInherited ? null : +(ratio * 1.03).toFixed(3)
      });
    });

    writes.forEach(function (w) {
      var st = w.el.style;
      vDhSite12Touched.push({
        el: w.el,
        fontSize: [st.getPropertyValue('font-size'), st.getPropertyPriority('font-size')],
        lineHeight: [st.getPropertyValue('line-height'), st.getPropertyPriority('line-height')]
      });
      vDhSite12Done.add(w.el);
      if (w.fontPx) st.setProperty('font-size', w.fontPx + 'px', 'important');
      if (w.lineHeight) st.setProperty('line-height', String(w.lineHeight), 'important');
    });
  }

  function vDhSite12Reset() {
    // Reverse order so an element touched twice ends on its true original value
    for (var i = vDhSite12Touched.length - 1; i >= 0; i--) {
      var t = vDhSite12Touched[i];
      t.el.style.setProperty('font-size', t.fontSize[0], t.fontSize[1]);
      t.el.style.setProperty('line-height', t.lineHeight[0], t.lineHeight[1]);
    }
    vDhSite12Touched = [];
    vDhSite12Done = new WeakSet();
  }

  // Size Guide button: snippets/dt-size-guide.liquid moves it into Globo's Size
  // label (an exact-size element, so the scaler skips it) and pins it at
  // 12px !important inline — override that inline value: 12 → 15.36 (×1.28)
  function vDhSite12SizeGuide() {
    document.querySelectorAll('.dt-size-guide__btn').forEach(function (btn) {
      if (btn.style.getPropertyValue('font-size') !== '15.36px') {
        btn.style.setProperty('font-size', '15.36px', 'important');
      }
    });
  }

  function vDhSite12Start() {
    if (vDhSite12Started) return;
    vDhSite12Started = true;
    vDhSite12Scale(document.body);
    vDhSite12SizeGuide();
    // Fonts are scaled: reveal the header group (hidden by c-custom.css until now, so the size jump is never seen)
    document.documentElement.classList.remove('c-vDhSite12Pending');

    // Content rendered later (cart drawer refreshes, Globo swatches, app widgets)
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && node.isConnected) vDhSite12Scale(node);
        });
      });
      vDhSite12SizeGuide();
    }).observe(document.body, { childList: true, subtree: true });

    // Breakpoints change the original sizes — restore and re-scale when one is crossed
    var breakpoints = [500, 601, 750, 768, 990];
    var bucket = function () {
      return breakpoints.filter(function (bp) { return window.innerWidth >= bp; }).length;
    };
    var lastBucket = bucket();
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var current = bucket();
        if (current === lastBucket) return;
        lastBucket = current;
        vDhSite12Reset();
        vDhSite12Scale(document.body);
      }, 200);
    });
  }

  // The body class is added on ig:ready, which can land before or after this script
  function vDhSite12Init() {
    if (document.body.classList.contains(VDH_SITE12_CLASS)) {
      vDhSite12Start();
      return;
    }
    var classObserver = new MutationObserver(function () {
      if (!document.body.classList.contains(VDH_SITE12_CLASS)) return;
      classObserver.disconnect();
      vDhSite12Start();
    });
    classObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vDhSite12Init);
  } else {
    vDhSite12Init();
  }
}());

// V_DH_CART_11 — Cart Sell-Out Urgency + Delivery Date
(function () {
  'use strict';

  // The "bought in the last hour" count is real order data rendered in Liquid
  // (snippets/c-cart-drawer.liquid), so this script only tracks block views.
  function initCart11() {
    var bodyClass = document.body.classList;
    if (!bodyClass.contains('c-vDhCart11VarA') && !bodyClass.contains('c-vDhCart11VarB')) return;

    var block = document.getElementById('c-cart11-urgency-block');
    if (!block) return;

    // Fire Intelligems custom event when the block enters view (once per page load).
    // The drawer re-render replaces the block, so the observer follows whichever block is current.
    if (!cart11ViewSent && block !== cart11ViewBlock) {
      if (cart11ViewObserver) cart11ViewObserver.disconnect();
      cart11ViewBlock = block;
      cart11ViewObserver = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting && !cart11ViewSent) {
          cart11ViewSent = true;
          window.igEvents = window.igEvents || [];
          window.igEvents.push({ event: 'urgency_delivery_block_view' });
          cart11ViewObserver.disconnect();
        }
      }, { threshold: 0.5 });
      cart11ViewObserver.observe(block);
    }
  }

  var cart11ViewSent = false;
  var cart11ViewBlock = null;
  var cart11ViewObserver = null;

  // Add-to-cart, quantity changes and other cart scripts re-render the drawer's contents
  // (a new block), so pick up the current block whenever <cart-drawer> changes
  function watchCart11Drawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(initCart11).observe(drawer, { childList: true, subtree: true });
  }

  // Run on DOM ready and again after ig:ready sets the body class
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCart11();
      watchCart11Drawer();
    });
  } else {
    initCart11();
    watchCart11Drawer();
  }
  window.addEventListener('ig:ready', function () {
    // Small delay so handleExperiments() in c-intelligems-tests.js can add the body class first
    setTimeout(initCart11, 0);
  });
}());
